const Heading = () => {
  return (
    <div className="px-14 mb-44">
      <div className="text-[228px] font-black font-myfont opacity-10 tracking-tighter">TRENDORIA</div>
    </div>
  );
};

export default Heading;
